import React from 'react'
import { useTabsNavigation, CrudTabs, CrudRoute } from 'elentari'
import MercadoriaForm from './MercadoriaForm'
import AnalistaMercadorias from './Analistas/AnalistaMercadorias'
import AnalistaMercadoriaForm from './Analistas/AnalistaMercadoriaForm'

function MercadoriaTabs() {
  const tabsNavigation = useTabsNavigation({
    mainPath: 'mercadorias',
    tabs: [
      { value: '', label: 'Mercadorias' },
      { value: 'analistasPreferenciais', label: 'Analistas Preferenciais' }
    ]
  })
  return (
    <CrudTabs {...tabsNavigation}>
      <div>
        <CrudRoute render={props => <MercadoriaForm {...props} />} />
        <CrudRoute
          name="analistasPreferenciais"
          render={props => (
            <AnalistaMercadorias
              onClickNew={tabsNavigation.toNewChild}
              onClickEdit={tabsNavigation.toEditChild}
              {...props}
            />
          )}
        />
        <CrudRoute
          name="analistasPreferenciais"
          isForm
          render={props => <AnalistaMercadoriaForm {...props} />}
        />
      </div>
    </CrudTabs>
  )
}

export default MercadoriaTabs
